declare module "@mui/material/styles" {
  interface PaletteColor {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    red: string;
    purple: string;
    yellow: string;
  }
}

export const primary = {
  100: "#cde3f3",
  200: "#9dc8e8",
  300: "#5a9ec4",
  400: "#1f6fa0",
  500: "#0b3a5d",
  main: "#0b3a5d",
  light: "#cde3f3",
  dark: "#082d4a",
  red: "#FF6B93",
  purple: "#5c6bc0",
  yellow: "#FF9777",
};

export const secondary = {
  100: "#bfbadf",
  200: "#ECEFF5",
  300: "#83868b", // outline or border
  400: "#94A4C4", // text muted
  500: "#1d2438", // main text
  main: "#1d2438", // main text
  light: "#F9F9F9",
  red: "#FF6B93",
  purple: "#5c6bc0",
  yellow: "#FF9777",
};

export const error = {
  main: "#FD396D",
};

export const success = {
  main: "#22BB33",
};

export const warning = {
  main: "#E8A317",
  dark: "#FFD600",
};

export const info = {
  main: "#2499EF",
};

export const text = {
  primary: secondary[500],
  secondary: secondary[400],
  disabled: secondary[300],
};
